<template>
    <header class="header">
        <div class="container">
            <div class="logo">
                <!-- <a href="#">商城Logo</a> -->
                <router-link to="/" class="logo-wrap" style="color: #000;">
                    <img v-if="siteInfo.logo" :src="$img(siteInfo.logo)" />
                    <img v-else src="@/assets/images/logo.png" />
                    <span class="logo-name">客淘天下商城</span>
                </router-link>
                <!-- <NsHeaderMid></NsHeaderMid> -->
            </div>
            <nav class="nav">
                <div>
                    <router-link to="/index">首页</router-link>
                    <router-link to="/category">商品分类</router-link>
                    <router-link to="/street">店铺街</router-link>
                </div>
            </nav>
            <div class="user-actions">
                <router-link v-if="!logined" to="/login" class="ns-text-color">您好，请登录</router-link>
                <span v-if="logined">
                    <router-link to="/member/index">{{ member.nickname || member.username }}</router-link>
                    <a @click="logout">退出</a>
                </span>
                <router-link v-if="!logined" to="/register">注册</router-link>
                <!-- <a href="#">登录</a>
                <a href="#">注册</a> -->
                <router-link to="/cart"><span class="cart">购物车<span class="cart-count" v-if="cartCount">{{ cartCount }}</span></span></router-link>
                <router-link to="/cms/help">帮助中心</router-link>
                <router-link to="/cms/notice">公告</router-link>
            </div>
        </div>
    </header>
</template>
  
<script>
import { mapGetters } from 'vuex';
import NsHeaderTop from "./NsHeaderTop"
import NsHeaderMid from "./NsHeaderMid"
import { tree } from "@/api/goods/goodscategory"
import { navList } from "@/api/website"
export default {
    props: {
        forceExpand: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isShopHover: false,
            isIndex: false,
            thisRoute: "",
            goodsCategoryTree: [],
            selectedCategory: -1,
            selectedGoodsCategoryTree: null,
            navList: [],
            navSelect: "",
            listItemActive: -1
        }
    },
    components: {
        NsHeaderTop,
        NsHeaderMid
    },
    computed: {
        ...mapGetters(['cartCount', 'siteInfo', 'defaultGoodsImage', 'member']),
        logined: function () {
            return this.member !== undefined && this.member !== "" && this.member !== {}
        }
    },
    beforeCreate() { },
    created() {
        this.$store.dispatch("member/member_detail")
        this.$store.dispatch("cart/cart_count")
        this.$store.dispatch('site/siteInfo');
        this.getTree()
        this.nav()
        if (this.$route.path == "/" || this.$route.path == "/index") this.isIndex = true
    },
    mounted() { },
    watch: {
        $route: function (curr) {
            this.initNav(curr.path)
            if (curr.path == "/" || curr.path == "/index") this.isIndex = true
            else this.isIndex = false

            if (curr.path == "/list") {
                this.navSelect = ""
            }
        }
    },
    methods: {
        logout() {
            this.$store.dispatch("member/logout")
        },
        getTree() {
            tree({
                level: 3,
                template: 2
            })
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.goodsCategoryTree = res.data
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message)
                })
        },
        nav() {
            navList({})
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.navList = res.data.list
                        for (let i in this.navList) {
                            this.navList[i]["url"] = JSON.parse(this.navList[i]["nav_url"]).url
                        }
                        this.initNav(this.$route.path)
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message)
                })
        },
        navUrl(url, target) {
            if (!url) return
            if (url.indexOf("http") == -1) {
                if (target) this.$router.pushToTab({ path: url })
                else this.$router.push({ path: url })
            } else {
                if (target) window.open(url)
                else window.location.href = url
            }
        },
        initNav(path) {
            for (let i in this.navList) {
                if (this.navList[i]["url"] == path) {
                    this.navSelect = path
                    continue
                }
            }
        },
        //鼠标移入显示商品分类
        shopHover() {
            this.isShopHover = true
        },
        //鼠标移出商品分类隐藏
        shopLeave() {
            this.isShopHover = false
            this.listItemActive = -1
        }
    }
}
</script>
  
<style scoped lang="scss">
a {
    cursor: pointer;
    margin: 0px 10px;
}

/* 顶部导航栏样式 */
.header {
    position: relative;
    z-index: 1;
    // margin-bottom: 60px;
    box-sizing: border-box;
    height: 70px;
    min-width: 1230px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 10px 20px !important;
}

.header .container {
    box-sizing: border-box;
    padding: 0px 20px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo a {
        color: #333;
        text-decoration: none;
        font-size: 20px;
        font-weight: bold;
    }

    .nav ul {
        list-style: none;
        display: flex;
    }

    .nav ul li {
        margin: 0 15px;
    }

    .nav ul li a {
        color: #333;
        text-decoration: none;
        font-weight: 500;
    }

    .user-actions a {
        color: #333;
        text-decoration: none;
        margin: 0 10px;
    }

    .user-actions a:hover {
        text-decoration: underline;
    }

    .logo-wrap {
        width: 240px;
        // height: 68px;
        height: 50px;
        display: block;

        img {
            max-width: 100%;
            max-height: 100%;
        }

        .logo-name {
            color: #000 !important;
            margin-left: 20px;
            font-family: "Roboto", sans-serif;
            font-weight: 600;
            font-size: 18px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
        }
    }

    .cart {
        position: relative;

        .cart-count {
            position: absolute;
            top: -6px;
            right: 10px;
            transform: translateY(-50%) translateX(100%);
            border-radius: 10px;
            color: #fff;
            display: inline-block;
            font-size: 12px;
            height: 18px;
            line-height: 18px;
            padding: 0 6px;
            text-align: center;
            white-space: nowrap;
            border: 1px solid #fff;
            background: $base-color !important;
            ;
        }
    }
}

.router-link-active {
    color: $base-color !important;
}
</style>
  